import Entity from './entity'

export default class Bin extends Entity<number>{
    code:string;
    warehouseCode :string;
    level : number;
    aisleCode :string;
    roomCode :string;
    binTypeCode :string;
    binTypeName : string;
    lastModificationTime: Date;
    lastModifierUserId: number;
    lastModifierUserName: string;
}